import React from "react";
import "./Navbar.css";
import { Link } from "react-router-dom";

function Navbar() {
  return (
    <div className="navBarContainer">
      <Link to="/" className="companyNameHeader">
        The Whole 9
      </Link>
      <ul className="navBarList">
        <li>
          <Link to="packages">Packages</Link>
        </li>
        <li>
          <Link to="about">About</Link>
        </li>
        <li>
          <Link to="contact">Contact</Link>
        </li>
      </ul>
    </div>
  );
}

export default Navbar;
